module.exports = __webpack_public_path__ + "static/media/envelope-light.6ff54cdd.svg";